import React from 'react';

import styles from './pollResultsStyles.scss';

import FlagItemModalContainer from 'buyside/components/container/FlagItemModalContainer';
import PollResultVisualsContainer from 'buyside/components/container/CompanyShow/PollResultVisualsContainer';

import FlagIcon from 'buyside/svgs/flag.svg';

class PollResults extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: true
    };
  }

  render() {
    const { question } = this.props;
    const { id, text, questionType, topAnswers, expirationMonths } = question;
    return (
      <div className={styles.pollResults}>
        <h2>{text}</h2>
        <div className={styles.resultsImage}>
          {questionType === 'text' ? (
            <div>
              Top answers:
              <ul className={styles.topAnswers}>
                {topAnswers.map((answer, idx) => (
                  <li key={idx}>{answer}</li>
                ))}
              </ul>
              <FlagItemModalContainer
                buttonOptions={{
                  text: (
                    <div className={styles.flagButton}>
                      <FlagIcon className={styles.flagIcon} />
                      <span>Flag inappropriate answer</span>
                    </div>
                  ),
                  type: 'link'
                }}
                itemId={id}
                type="CompanyQuestion"
                name="User-Submitted Answer"
              />
            </div>
          ) : (
            <PollResultVisualsContainer question={question} />
          )}
        </div>
        <p className={styles.resultsText}>
          You unlocked access to these results{' '}
          {expirationMonths === 1
            ? 'through the end of this month'
            : `for ${expirationMonths} months`}
          .
        </p>
      </div>
    );
  }
}

export default PollResults;
